// extracted by mini-css-extract-plugin
module.exports = {"row":"row--2X1ZS"};